// extracted by mini-css-extract-plugin
module.exports = {"comment_box":"comment_box-3YygDioC"};